/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.querySelector('.thb-quick-search');
    this.button = document.getElementById('quick-search');
    this.close_button = this.container.querySelector('.thb-search-close');
    this.input = this.container.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.container.querySelector('.thb-quick-search--results');

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.container.querySelector('form.searchform');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.button.addEventListener('click', (event) => {
      var _this = this;
      event.preventDefault();
      document.querySelector('.header-section').classList.toggle('search-open');

      if (document.querySelector('.header-section').classList.contains('search-open')) {
        setTimeout(function () {
          _this.input.focus({
            preventScroll: true
          });
        }, 100);
        dispatchCustomEvent('search:open');
      }

      return false;
    });

    // Close.
    this.close_button.addEventListener('click', (event) => {
      this.close();
      event.preventDefault();
    });
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  categoryToggle() {
    this.category_toggle = this.container.querySelectorAll('.search-categories a');

    this.category_toggle.forEach((link) => {
      link.addEventListener('click', (event) => {
        [].forEach.call(this.category_toggle, function (el) {
          el.classList.remove('active');
        });
        link.classList.add('active');
        let target = link.getAttribute('href');
        this.container.querySelectorAll('.search-results').forEach((section) => {
          section.classList.remove('active');
        });
        this.container.querySelector(target).classList.add('active');

        event.preventDefault();
      });
    });

  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.searchController?.abort();
      this.predictiveSearchResults.classList.remove('active', 'loading');
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    this.searchController?.abort();
    const controller = new AbortController();
    this.searchController = controller;
    const plan = window.PremierSearch?.analyze(searchTerm);
    const query = plan?.searchQuery || searchTerm;
    const types = plan?.sku ? 'product' : 'product,article,query';
    this.predictiveSearchResults.classList.add('loading');
    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(query)}&${encodeURIComponent('resources[type]')}=${types}&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`, { signal: controller.signal })
      .then(response => {
        if (!response.ok) throw new Error('Search suggestions could not be loaded');
        return response.text();
      })
      .then(text => {
        if (controller.signal.aborted || searchTerm !== this.getQuery()) return;
        const markup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
        if (markup) this.renderSearchResults(markup, plan);
      })
      .catch(() => {})
      .finally(() => {
        if (this.searchController === controller) this.predictiveSearchResults.classList.remove('loading');
      });
  }

  renderSearchResults(markup, plan) {
    if (plan) markup.querySelector('#predictive-search-results')?.setAttribute('data-premier-query', plan.raw);
    if (plan && window.PremierSearch) {
      const cards = Array.from(markup.querySelectorAll('[data-premier-id]')).map(card => ({ card, result: window.PremierSearch.prepareCard(card, plan) }));
      const hasExact = cards.some(item => item.result.exactSku);
      cards.forEach(({ card, result }) => {
        if (!result.match || (hasExact && !result.exactSku)) card.remove();
      });
      const products = markup.querySelector('#predictive-results-product');
      if (products && !products.querySelector('[data-premier-id]')) {
        products.remove();
        markup.querySelector('a[href="#predictive-results-product"]')?.remove();
      }
      if (!markup.querySelector('.search-results.active')) {
        markup.querySelector('.search-results')?.classList.add('active');
        markup.querySelector('.search-categories a')?.classList.add('active');
      }
      const empty = markup.querySelector('[data-premier-predictive-empty]');
      if (empty) empty.hidden = !!markup.querySelector('.search-results');
    }
    this.predictiveSearchResults.innerHTML = markup.innerHTML;
    this.predictiveSearchResults.classList.add('active');
    this.categoryToggle();
  }

  open() {
    document.querySelector('.header-section').classList.add('search-open');
  }

  close() {
    document.querySelector('.header-section').classList.remove('search-open');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});